export function includesProtocolPrefix(url: string) {
  return /^(\w+):\/\/(.+)/.test(url);
}
